export type PageRequest =
    | { kind: 'first' }
    | { kind: 'last' }
    | { kind: 'after'; token: unknown }
    | { kind: 'before'; token: unknown }
    | { kind: 'at'; index: number };

export interface PageResult<T> {
    rows: T[];
    totalCount?: number;
    offset?: number;
    nextToken?: unknown;
    prevToken?: unknown;
    hasNext?: boolean;
    hasPrev?: boolean;
}

export interface Paging {
    offset: number;
    hasNext: boolean;
    hasPrev: boolean;
    pageCount?: number;
}

export function derivePaging(
    page: number,
    pageSize: number | undefined,
    res: PageResult<unknown>,
    lastPage: boolean,
): Paging {
    const total = res.totalCount;
    const fallback = page === 0 || !pageSize ? 0 : page * pageSize;
    const offset =
        res.offset ??
        (lastPage && total !== undefined ? total - res.rows.length : fallback);
    const hasNext =
        res.hasNext ??
        (total !== undefined && pageSize
            ? offset + res.rows.length < total
            : res.rows.length === pageSize);
    const hasPrev = res.hasPrev ?? page > 0;
    const pageCount =
        total !== undefined && pageSize
            ? Math.ceil(total / pageSize)
            : undefined;
    return { offset, hasNext, hasPrev, pageCount };
}

export function lastPageIndex(
    totalCount: number | undefined,
    pageSize: number | undefined,
): number | undefined {
    if (totalCount === undefined || !pageSize) return undefined;
    return Math.max(0, Math.ceil(totalCount / pageSize) - 1);
}
